module.exports = __webpack_public_path__ + "img/main-banner-info-users-eng.cd637004.png";